export default {"src":"/_next/static/media/CROSS.d5097b67.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};